module.exports = __webpack_public_path__ + "static/media/shengdiao2.fce63869.png";